// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yF8a","question":"styles_question__lYn1c","description":"styles_description__1mw5Y"};